<template>
  <b-navbar toggleable="md" variant="light" type="light" class="nav">
    <b-navbar-brand href="#" @click.prevent="$router.push('/')" class="brand">THINKss + 健康バス</b-navbar-brand>
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template slot="button-content">
            <em>その他</em>
          </template>
          <b-dropdown-item href="/signout">サインアウト</b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'bfheader'
}
</script>
<style scoped>
.nav {
  border-bottom: 5px solid #c8dff2;
}
.brand {
  color: #0b447c;
}
</style>
